<template lang="html">

  <div class="vive-aldonza">

    <section class="banner-intro full-view-intro column-center animation" data="vive-aldonza">

      <h1 class="title -intro">{{$t('vistas.vive_aldonza')}}</h1>

      <h2 class="subtitle-intro">{{$t('vistas.experiencias')}}</h2>

      <a class="enlace-intro" style="padding-top: 10px; text-align: center; z-index: 3;" :href="$t('enlaces.mejor_bodega_CM')" target="_blank">
        <u style="font-weight: 500;">{{ $t('mejor_bodega_CM') }}</u>
      </a>

      <a :href="$t('enlaces.experiencias_13')" target="_blank" class="btn" v-if="lang != 'ja'">
        <span v-html="$t('banners_experiencia.enoturismo.reserva')"></span>
      </a>

        <video controls="false" loop="true" muted="true" id="vive-aldonza-full" autoplay="true" playsinline :launched="launched">
    <source src="/static/video/vive-aldonza-full.mp4" type="video/mp4">
    </video>


    </section>

    <section class="intro-experiencias">

      <article class="claim container -xs animation">
        <h2 class="title">{{$t('banners_experiencia.vive_aldonza.titulo_intro_experiencia')}}.</h2>
      </article>

      <div class="contenedor-info container animation">

        <h2 class="title">{{$t('banners_experiencia.vive_aldonza.titulo_vivir_experiencia')}}</h2>

        <div class="experiencias-list row-center ais animation">
          <article class="experiencia-el">
            <span><img src="/static/img/icon-maleta.svg"></span>
            <p v-html="$t('banners_experiencia.vive_aldonza.tip_maleta')"></p>
          </article>
          <article class="experiencia-el">
            <span><img src="/static/img/icon-camara.svg"></span>
            <p class="separacion-palabras" v-html="$t('banners_experiencia.vive_aldonza.tip_camara')"></p>
          </article>
          <article class="experiencia-el">
            <span><img src="/static/img/icon-corazon.svg"></span>
            <p v-html="$t('banners_experiencia.vive_aldonza.tip_corazon')"></p>
          </article>
        </div>

        <h3 class="title -ghost"></h3>

      </div>


    </section>

    <banner-enoturismo></banner-enoturismo>
    <banner-oleoturismo></banner-oleoturismo>
    <banner-recetario></banner-recetario>

    <banner-degustacionQuesos></banner-degustacionQuesos>
    <banner-ruta-cervantina></banner-ruta-cervantina>
    <div class="contenedor-blog launched">
      <blog></blog>
    </div>

    <div class="otras-experiencias animation">

      <div class="contenedor-experiencia container">

        <h2 class="title -ghost">{{$t('otras_experiencias.titulo')}}</h2>

        <section class="row-center ais banner-container-escucha">

          <article class="contenedor-imagen"></article>

          <article 
          class="banner-escucha-aldonza column-center"
          @mouseover="playVideo('video-escucha')" @mouseleave="pausevideo('video-escucha')">
          <router-link :to="$t('enlaces.escucha_aldonza')" class="enlace-cover" ></router-link>
          <router-link :to="$t('enlaces.escucha_aldonza')" class="btn spotify row-start">
            <img src="/static/img/logo-spotify.png" height="48">
            <span>{{$t('vistas.escucha_aldonza')}}</span>
          </router-link>
          <video controls="false" loop="true" muted="true" id="video-escucha">
            <source src="/static/video/video-escucha.mp4" type="video/mp4">
            </video>
          </article>

        </section>

      </div>

    </div>


  </div>

</template>

<script lang="js">

  import bannerEnoturismo from '@/components/parts/banner-enoturismo'
  import bannerRecetario from '@/components/parts/banner-recetario'
  import bannerOleoturismo from '@/components/parts/banner-oleoturismo'
  import bannerDegustacionQuesos from '@/components/parts/banner-degustacion-quesos'
  import bannerRutaCervantina from '@/components/parts/banner-ruta-cervantina'

  import {mapGetters, mapActions} from 'vuex'

  import blog from '@/components/parts/blog'

  export default  {
    name: 'vive-aldonza',
    mounted(){
      this.requestVideos();
    },
    components: {
      'banner-enoturismo' : bannerEnoturismo,
      'banner-recetario' : bannerRecetario,
      'banner-oleoturismo' :bannerOleoturismo,
      'banner-ruta-cervantina' :bannerRutaCervantina,
      'banner-degustacionQuesos': bannerDegustacionQuesos,
      'blog' : blog
    },
    methods : {
      ...mapActions(['requestVideos']),
      playVideo :function(name) {
        $("#"+name)[0].play();
        (name == 'video-escucha') ? this.experiencia = 'escucha' : '';
      },
      pausevideo : function(name){
        $("#"+name)[0].pause();
        (name == 'video-escucha') ? this.experiencia = '' : '';
      },
    },
    computed : {
      ...mapGetters({
        lang : 'getLanguage',
      })
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .full-view-intro[data="vive-aldonza"]{
    /*background: url(/static/img/vive-aldonza/background-intro-vive-aldonza.jpg) center/cover no-repeat;*/

    .title,.subtitle-intro, .btn{
      position: relative;
      z-index: 3;
    }
  }

  .btn{
    margin-top: 30px;
  }

    #vive-aldonza-full{
    position: absolute;
    left: 50%;
    top: 50%;
    min-height: 100vh;
    min-width: 100vw;
    transform: translate(-50%,-50%);
  }


  .intro-experiencias{
    width: 100%;
    background: $plum;
    padding-bottom: 0;
  }


  .contenedor-blog{
    padding-top: 100px;
  }

  .btn.spotify{
    padding-left: 0;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    span{
      margin-left: 20px;
    }
    img{
      display: block;
    }
  }


  @media screen and (max-width: 767px){
    .intro-experiencias .contenedor-info{
      padding: 0;
    }
  }


  @media screen and (max-width: 600px){
    .contenedor-blog{
      padding-top: 50px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/vive-aldonza.vue